import Vue from "vue";
import store from "../store/index";
import Router from "vue-router";
// import HelloWorld from "@/components/HelloWorld";

Vue.use(Router);

var npush = Router.prototype.push;
Router.prototype.push = function (loction) {
  return npush.call(this, loction).catch((err) => err);
};

const router = new Router({
  mode: "history",
  routes: [
    {
      path: "/login",
      component: () => import("@/views/login"),
      hidden: true,
    },
    {
      path: "/404",
      component: () => import("@/views/404"),
      hidden: true,
    },
    {
      path: "/",
      name: "home",
      component: () => import("@/views/index"),
    },
    {
      path: "/detail",
      component: () => import("@/views/detail"),
      meta: { title: "详情" },
      hidden: true,
    },
    {
      path: "/agreement",
      component: () => import("@/views/agreement"),
      meta: { title: "用户协议" },
      hidden: true,
    },
    {
      path: "/policy",
      component: () => import("@/views/policy"),
      meta: { title: "隐私政策" },
      hidden: true,
    },
  ],
});

router.beforeEach((to, from, next) => {
  const hastoken = localStorage.getItem("token");
  

  console.log("tototo", to, hastoken);

  if (!hastoken) {
    localStorage.removeItem("token");
    if (to.path == "/agreement" || to.path == "/policy") {
      next();
    } else if (to.path !== "/login") {
      next({ path: "/login" });
    } else {
      next();
    }
  } else {
    console.log("有token");
    store.dispatch("getuserInfo");
  }
  next();
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js